export function setConfig (key, value) {
  const config = {
    [key]: value
  }
  return {
    type: 'SET_CONFIG',
    config
  }
}
export function setLayout (layout) {
  return {
    type: 'SET_LAYOUT',
    layout
  }
}

export function setPermissionAction (permissions, selectedLanguage, userType) {
  return {
    type: 'SET_PERMISSIONS',
    permissions,
    selectedLanguage,
    userType
  }
}



// WEBPACK FOOTER //
// ./src/actions/config.js